(function(){
document.querySelectorAll('.glp-1-skin-plan-source').forEach(sourceRoot => {
if (sourceRoot.dataset.initialized === 'true') return;
sourceRoot.dataset.initialized = 'true';

/* ============ STATE ============ */
const state = {
  skinType:null, goal:null, med:null, bodyZones:[], typicalDay:null, movement:null,
  stress:null, water:null, motivation:null, confidence:null,
  event:null, eventDate:null, name:''
};

const FLOW = ['skinType','goal','med','medImpact','enemy','bodyMap','emotion','typicalDay',
              'movement','stress','water','science','video','timeline','proof','showcase',
              'motivation','confidence','event','date','name','loading','result'];
const TOTAL_STEPS = 13; // numbered steps only
let idx = 0;
let history = [];

let wugVideoGlobal = null;
const screens = {};
sourceRoot.querySelectorAll('.screen').forEach(s => screens[s.dataset.id] = s);
const hdr = sourceRoot.querySelector('#hdr');
const progressFill = sourceRoot.querySelector('#progressFill');
const stepCount = sourceRoot.querySelector('#stepCount');
const ctaDock = sourceRoot.querySelector('#ctaDock');
const continueBtn = sourceRoot.querySelector('#continueBtn');
const skipBtn = sourceRoot.querySelector('#skipBtn');
const backBtn = sourceRoot.querySelector('#backBtn');

/* ============ PERSONALIZATION MAPS ============ */
const MED_LABEL = {Ozempic:'Ozempic', Mounjaro:'Mounjaro', Wegovy:'Wegovy', Zepbound:'Zepbound', Other:'GLP-1'};

const RESULT_MAP = {
  firm:{h:'your skin lost its structure faster than it could rebuild. Here\u2019s how to support it back.', tags:['Firmness support','Deep hydration','Barrier defense']},
  elasticity:{h:'the bounce didn\u2019t disappear. It just needs the right support to come back.', tags:['Elasticity support','Bioidentical fats','Post-GLP-1 recovery']},
  glow:{h:'you did the hard part. Now let\u2019s bring your glow back.', tags:['Glow recovery','Nutrient-rich','Non-comedogenic']},
  lines:{h:'rapid change left its mark. Deep nourishment helps smooth the look.', tags:['Smoothing support','Deep hydration','Clean formula']}
};

/* ============ NAV ============ */
function updateHeader(screen){
  const isFlash = screen.hasAttribute('data-flash');
  hdr.classList.toggle('no-progress', isFlash);
  backBtn.classList.toggle('show', idx > 0 && screen.dataset.id !== 'result' && screen.dataset.id !== 'loading');
  if(!isFlash){
    const step = parseInt(screen.dataset.step,10);
    stepCount.textContent = step + '/' + TOTAL_STEPS;
    progressFill.style.width = (step/TOTAL_STEPS*100) + '%';
  }
}

function updateDock(){
  const id = FLOW[idx];
  const needsContinue = ['medImpact','enemy','bodyMap','emotion','science','video','timeline','proof','showcase','date','name'].includes(id);
  ctaDock.classList.toggle('show', needsContinue);
  skipBtn.style.display = (id === 'date') ? 'block' : 'none';
  if(id==='bodyMap') continueBtn.disabled = state.bodyZones.length===0;
  else if(id==='date') continueBtn.disabled = !state.eventDate;
  else if(id==='name') continueBtn.disabled = sourceRoot.querySelector('#firstName').value.trim().length===0;
  else continueBtn.disabled = false;
  continueBtn.textContent = (id==='name') ? 'Build My Recovery Plan →' : 'Continue';
}

function show(i, push=true){
  const cur = sourceRoot.querySelector('.screen.active');
  if(wugVideoGlobal && wugVideoGlobal.pause && !wugVideoGlobal.paused) wugVideoGlobal.pause();
  const nextId = FLOW[i];
  const next = screens[nextId];
  if(push && cur) history.push(idx);
  idx = i;
  if(cur){
    cur.classList.add('leaving');
    setTimeout(()=>{cur.classList.remove('active','leaving'); activate(next);},260);
  } else activate(next);
}

function activate(next){
  next.classList.add('active');
  updateHeader(next);
  updateDock();
  const id = next.dataset.id;
  if(id==='medImpact') fillMedImpact();
  if(id==='date') fillDateTitle();
  
  if(id==='loading') runLoading();
  if(id==='result') buildResult();
}

function goNext(){
  if(idx < FLOW.length-1) show(idx+1);
}
backBtn.addEventListener('click', ()=>{
  if(history.length){ const prev = history.pop(); show(prev,false); }
});
continueBtn.addEventListener('click', goNext);
skipBtn.addEventListener('click', ()=>{ state.eventDate = null; dateLabel.textContent='Select a date'; dateLabel.classList.add('date-placeholder'); dateLabel.classList.remove('date-set'); calPanel.classList.remove('open'); goNext(); });

/* ============ OPTION HANDLERS ============ */
sourceRoot.querySelectorAll('.options[data-single]').forEach(group=>{
  group.querySelectorAll('.opt').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      group.querySelectorAll('.opt').forEach(b=>b.classList.remove('selected'));
      btn.classList.add('selected');
      state[group.dataset.key] = btn.dataset.val;
      setTimeout(goNext, 320);
    });
  });
});
sourceRoot.querySelectorAll('.options[data-multi]').forEach(group=>{
  group.querySelectorAll('.opt').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      btn.classList.toggle('selected');
      const key = group.dataset.key;
      const val = btn.dataset.val;
      if(btn.classList.contains('selected')) state[key].push(val);
      else state[key] = state[key].filter(v=>v!==val);
      updateDock();
    });
  });
});

/* ============ BODY MAP ============ */
const bGlowMap = {
  neck:['bg-neck'], face:['bg-face'], arms:['bg-arms-l','bg-arms-r'], abdomen:['bg-abdomen']
};
function toggleBZone(z){
  const on = state.bodyZones.includes(z);
  if(on) state.bodyZones = state.bodyZones.filter(v=>v!==z);
  else state.bodyZones.push(z);
  (bGlowMap[z]||[]).forEach(id=>{const el=sourceRoot.querySelector('#'+id); if(el) el.classList.toggle('on', !on);});
  sourceRoot.querySelectorAll('.body-chip[data-bzone="'+z+'"]').forEach(c=>c.classList.toggle('selected', !on));
  sourceRoot.querySelectorAll('.hot[data-bzone="'+z+'"]').forEach(c=>c.classList.toggle('selected', !on));
  updateDock();
}
sourceRoot.querySelectorAll('.hot').forEach(el=>el.addEventListener('click', ()=>toggleBZone(el.dataset.bzone)));
sourceRoot.querySelectorAll('.body-chip').forEach(el=>el.addEventListener('click', ()=>toggleBZone(el.dataset.bzone)));

/* ============ FLASH 1 ============ */
function fillMedImpact(){
  const label = MED_LABEL[state.med] || 'GLP-1';
  sourceRoot.querySelector('#medImpactTitle').textContent = 'What happens to your skin on ' + label;
  sourceRoot.querySelector('#medPill').textContent = label;
  const isOther = (state.med==='Other' || !state.med);
  sourceRoot.querySelector('#medImpactBody').textContent = isOther
    ? 'As fat stores shrink quickly, the volume underneath your skin can empty out faster than your skin can adapt \u2014 so your face and body may start to look tired, deflated, or looser than you expected.'
    : 'Treatments like ' + label + ' reduce fat stores fast \u2014 and the volume underneath your skin can empty out faster than your skin adapts. That\u2019s why your face and body may look tired, deflated, or looser than you expected.';
}

/* ============ DATE ============ */
function fillDateTitle(){
  const ev = state.event && state.event!=='Just for myself' ? state.event.toLowerCase() : null;
  sourceRoot.querySelector('#dateTitle').textContent = ev ? ('When is your '+ev+'?') : 'When do you want to see a difference by?';
  renderCal();
}

/* ---- custom English calendar ---- */
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
let calView = (()=>{const t=new Date();return {y:t.getFullYear(), m:t.getMonth()};})();
const calPanel = sourceRoot.querySelector('#calPanel');
const dateField = sourceRoot.querySelector('#dateField');
const dateLabel = sourceRoot.querySelector('#dateLabel');

function calMin(){const t=new Date();t.setHours(0,0,0,0);t.setDate(t.getDate()+1);return t;}
function iso(d){return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');}

function renderCal(){
  sourceRoot.querySelector('#calMonth').textContent = MONTHS[calView.m]+' '+calView.y;
  const grid = sourceRoot.querySelector('#calGrid');
  grid.innerHTML = '';
  const first = new Date(calView.y, calView.m, 1);
  const daysIn = new Date(calView.y, calView.m+1, 0).getDate();
  const min = calMin();
  const today = new Date(); today.setHours(0,0,0,0);
  for(let i=0;i<first.getDay();i++){const s=document.createElement('span');grid.appendChild(s);}
  for(let d=1;d<=daysIn;d++){
    const dt = new Date(calView.y, calView.m, d);
    const b = document.createElement('button');
    b.type='button'; b.className='cal-day'; b.textContent=d;
    if(dt < min) b.classList.add('disabled');
    else b.addEventListener('click', ()=>selectDate(dt));
    if(dt.getTime()===today.getTime()) b.classList.add('today');
    if(state.eventDate===iso(dt)) b.classList.add('selected');
    grid.appendChild(b);
  }
  const prevDisabled = new Date(calView.y, calView.m+1, 0) < calMin();
  sourceRoot.querySelector('#calPrev').disabled = prevDisabled;
}
function selectDate(dt){
  state.eventDate = iso(dt);
  dateLabel.textContent = MONTHS[dt.getMonth()]+' '+dt.getDate()+', '+dt.getFullYear();
  dateLabel.classList.remove('date-placeholder');
  dateLabel.classList.add('date-set');
  calPanel.classList.remove('open');
  renderCal();
  updateDock();
}
dateField.addEventListener('click', ()=>{calPanel.classList.toggle('open');});
sourceRoot.querySelector('#calPrev').addEventListener('click', ()=>{calView.m--; if(calView.m<0){calView.m=11;calView.y--;} renderCal();});
sourceRoot.querySelector('#calNext').addEventListener('click', ()=>{calView.m++; if(calView.m>11){calView.m=0;calView.y++;} renderCal();});
sourceRoot.querySelector('#firstName').addEventListener('input', e=>{
  state.name = e.target.value.trim(); updateDock();
});

/* ============ COUNTERS ============ */
function animateCounters(){
  sourceRoot.querySelectorAll('[data-count]').forEach(el=>{
    const target = parseInt(el.dataset.count,10);
    let cur = 0;
    const step = ()=> {
      cur += Math.ceil(target/32);
      if(cur>=target){el.textContent = target+'%';}
      else {el.textContent = cur+'%'; requestAnimationFrame(step);}
    };
    requestAnimationFrame(step);
  });
}

/* ============ LOADING SEQUENCE ============ */
let microAnswered = false;
function runLoading(){
  const fill = sourceRoot.querySelector('#loadFill');
  const items = sourceRoot.querySelectorAll('.check-item');
  items.forEach(i=>i.classList.remove('done'));
  fill.style.width = '0%';
  microAnswered = false;
  const seq = [
    {t:600, w:'22%', li:0},
    {t:1500, w:'45%', li:1},
    {t:2300, w:'58%', modal:true},
  ];
  seq.forEach(s=>setTimeout(()=>{
    fill.style.width = s.w;
    if(s.li!==undefined) items[s.li].classList.add('done');
    if(s.modal) sourceRoot.querySelector('#modalVeil').classList.add('show');
  }, s.t));
}
function answerMicro(yes){
  if(microAnswered) return; microAnswered = true;
  const reply = sourceRoot.querySelector('#microReply');
  reply.style.display = 'block';
  reply.textContent = yes ? 'Perfect. Your plan is built for exactly that.' : 'That\u2019s why your plan has just one step.';
  setTimeout(()=>{
    sourceRoot.querySelector('#modalVeil').classList.remove('show');
    const fill = sourceRoot.querySelector('#loadFill');
    const items = sourceRoot.querySelectorAll('.check-item');
    setTimeout(()=>{fill.style.width='78%'; items[2].classList.add('done');},300);
    setTimeout(()=>{fill.style.width='100%'; items[3].classList.add('done');},1200);
    setTimeout(()=>show(FLOW.indexOf('result')),2100);
  },1100);
}

/* ============ TIER LOGIC ============ */
function daysToEvent(){
  if(!state.eventDate) return null;
  return Math.round((new Date(state.eventDate) - new Date())/86400000);
}
function computeTier(){ return 1; }

/* ============ RESULT BUILD ============ */
function buildResult(){
  const map = RESULT_MAP[state.goal] || RESULT_MAP.glow;
  const name = state.name ? state.name.charAt(0).toUpperCase()+state.name.slice(1) : 'Friend';
  sourceRoot.querySelector('#resultHeadline').textContent = name + ', ' + map.h;
  sourceRoot.querySelector('#resultTags').innerHTML = map.tags.map(t=>'<span class="tag">'+t+'</span>').join('');

  /* result paragraph — personalized by med + body zones */
  const label = (MED_LABEL[state.med] && state.med!=='Other') ? MED_LABEL[state.med] : 'rapid weight loss';
  const zoneNames = {neck:'jawline & neck', face:'facial contours', arms:'arms', abdomen:'abdomen & body'};
  const zones = state.bodyZones.map(z=>zoneNames[z]).filter(Boolean);
  let zoneStr = '';
  if(zones.length===1) zoneStr = ' around your '+zones[0];
  else if(zones.length===2) zoneStr = ' around your '+zones[0]+' and '+zones[1];
  else if(zones.length>=3) zoneStr = ' across the areas you marked';
  sourceRoot.querySelector('#resultPara').innerHTML =
    'Based on your answers, your plan is built around the <b>The Everything Cream</b> — deep, restructuring-feel hydration made to support skin firmness and glow'+zoneStr+' after '+label+'. Grass-fed tallow, colostrum, and propolis, in one simple daily step.';

  /* event-based CTA copy */
  const ev = state.event && state.event!=='Just for myself' ? state.event.toLowerCase() : null;
  const fmt = dt => dt.toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});
  sourceRoot.querySelector('#chartSub').textContent = (ev && state.eventDate)
    ? 'Paced for your '+ev+' on '+fmt(new Date(state.eventDate))+'.'
    : 'Typical pacing with consistent daily use.';
  if(ev && state.eventDate){
    sourceRoot.querySelector('#finalCtaTitle').textContent = 'Your '+ev+' is on the calendar.';
    sourceRoot.querySelector('#finalCtaSub').textContent = 'Give your skin the head start — backed by the 180-day guarantee.';
  }

  syncSticky();
  sourceRoot.querySelector('#stickyCta').classList.add('show');
}

function syncSticky(){
  var p = sourceRoot.querySelector('#stickyPrice'); if(p) p.textContent = sourceRoot.dataset.productPrice || '$34.99';
  var l = sourceRoot.querySelector('#stickyPlan'); if(l) l.textContent = sourceRoot.dataset.productName || 'The Everything Cream';
}

function goToPlan(){
  window.location.href = sourceRoot.dataset.productUrl || '/products/lumi-moisturizer';
}


/* ============ FAQ ============ */
sourceRoot.querySelectorAll('.faq-item').forEach(item=>{
  item.querySelector('.faq-q').addEventListener('click', ()=>{
    const open = item.classList.contains('open');
    sourceRoot.querySelectorAll('.faq-item').forEach(i=>{i.classList.remove('open'); i.querySelector('.faq-a').style.maxHeight=null;});
    if(!open){
      item.classList.add('open');
      const a = item.querySelector('.faq-a');
      a.style.maxHeight = a.scrollHeight+'px';
    }
  });
});

/* ============ BEFORE/AFTER SLIDER ============ */
(function(){
  const wrap = sourceRoot.querySelector('#baWrap');
  const after = sourceRoot.querySelector('#baAfter');
  const handle = sourceRoot.querySelector('#baHandle');
  let dragging = false;
  function setPos(clientX){
    const r = wrap.getBoundingClientRect();
    let pct = ((clientX - r.left)/r.width)*100;
    pct = Math.max(4, Math.min(96, pct));
    after.style.clipPath = 'inset(0 0 0 '+pct+'%)';
    handle.style.left = pct+'%';
  }
  const start = e=>{dragging=true; setPos(e.touches?e.touches[0].clientX:e.clientX);};
  const move = e=>{if(dragging) setPos(e.touches?e.touches[0].clientX:e.clientX);};
  const end = ()=>dragging=false;
  wrap.addEventListener('mousedown',start); window.addEventListener('mousemove',move); window.addEventListener('mouseup',end);
  wrap.addEventListener('touchstart',start,{passive:true}); window.addEventListener('touchmove',move,{passive:true}); window.addEventListener('touchend',end);
})();


wugVideoGlobal = sourceRoot.querySelector('#wugVideo');

/* ============ STRESS SCALE ============ */
sourceRoot.querySelectorAll('.scale-row .scale-btn').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    btn.parentElement.querySelectorAll('.scale-btn').forEach(b=>b.classList.remove('selected'));
    btn.classList.add('selected');
    state.stress = btn.dataset.val;
    setTimeout(goNext, 340);
  });
});

/* video slide is a static placeholder — no JS needed until real video is embedded */

sourceRoot.querySelectorAll('[data-glp-action="plan"]').forEach(btn=>{
  btn.addEventListener('click', goToPlan);
});
sourceRoot.querySelectorAll('[data-glp-action="micro-no"]').forEach(btn=>{
  btn.addEventListener('click', ()=>answerMicro(false));
});
sourceRoot.querySelectorAll('[data-glp-action="micro-yes"]').forEach(btn=>{
  btn.addEventListener('click', ()=>answerMicro(true));
});

/* ============ INIT ============ */
show(0,false);

});
})();
